export default __webpack_public_path__ + "static/media/bell.6882da97.svg";